module.exports = __webpack_public_path__ + "static/media/user.99978599.svg";